var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "j-mavon-editor"
  }, [_c('mavon-editor', {
    ref: "md",
    attrs: {
      "toolbars": _vm.toolbars,
      "editable": _vm.editable,
      "subfield": _vm.subfield,
      "defaultOpen": _vm.defaultOpen
    },
    on: {
      "imgAdd": _vm.imgAdd,
      "imgDel": _vm.imgDel,
      "change": _vm.change,
      "save": _vm.save
    },
    model: {
      value: _vm.myValue,
      callback: function callback($$v) {
        _vm.myValue = $$v;
      },
      expression: "myValue"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };